import {
  Armchair,
  ArrowUpDown,
  BedDouble,
  Bike,
  Joystick,
  Accessibility,
  MoveVertical,
  Hammer,
  CircuitBoard,
} from "lucide-react";

export const business = {
  name: "JRs Chair Repair",
  legalName: "JRs Chair Repair",
  tagline: "Medical Mobility Equipment",
  subTagline: "Delivery & Repair",
  owner: "John Martin Jr",
  phone: "814-410-5822",
  phoneHref: "tel:+18144105822",
  smsHref: "sms:+18144105822",
  email: "JRsChairRepair@gmail.com",
  emailHref: "mailto:JRsChairRepair@gmail.com",
  google: "https://www.google.com/search?q=JRs+Chair+Repair+LLC",
  location: "Richland Township, PA",
  region: "Greater Johnstown",
  credentials: "PA Registered & Insured",
  logo: "https://customer-assets.emergentagent.com/job_46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/artifacts/i2xlbd2k_IMG_2237.jpeg",
  logoMono: "https://customer-assets.emergentagent.com/job_equipment-locator-7/artifacts/h7dkxc11_51346A9D-4AD8-4CD1-BE30-E9853AFBC6DA.jpeg",
  ribbon: "Proudly supporting Veteran mental health & suicide awareness",
};

export const heroImages = {
  main: "https://images.unsplash.com/photo-1543333995-a78aea2eee50?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  caregiver: "https://images.pexels.com/photos/18429307/pexels-photo-18429307.jpeg?auto=compress&cs=tinysrgb&w=1400",
  scooter: "https://images.unsplash.com/photo-1768528388214-1c465f4950ec?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const services = [
  {
    slug: "lift-chairs",
    title: "Recliner / Lift Chairs",
    icon: Armchair,
    short: "Power lift recliners that help you sit and stand with ease and total comfort.",
    image: "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/f2ca8dfe147f8dcb56d799813049fdc0d9a37541d68b33ef4d98641160c4c83d.png",
    details: [
      "Single, dual & infinite-position power lift recliners",
      "Motor, hand-control & power-cord replacement",
      "Recliner & lift mechanism adjustments",
    ],
    products: [
      { brand: "Golden Technologies", name: "MaxiComfort\u00ae & PR-Series Lift Recliners" },
      { brand: "Pride Mobility", name: "VivaLift!\u00ae Power Lift Recliners" },
      { brand: "Drive DeVilbiss", name: "Power Lift Recliners" },
      { brand: "Medline", name: "Lift Chairs & Recliners" },
    ],
  },
  {
    slug: "stair-lifts",
    title: "Stair Lifts",
    icon: ArrowUpDown,
    short: "Straight and curved stair lifts to keep every floor of your home accessible.",
    image: "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/bf31e8fe3f0dbdfb8d5c4eca5b4db3a2161daf80a90f2c4bd0090f1025acf3d7.png",
    details: [
      "Straight & curved staircase solutions",
      "Safety sensor & battery service",
      "Professional measuring & installation",
    ],
    products: [
      { brand: "Acorn Stairlifts", name: "Straight & Curved Stairlifts" },
      { brand: "Bruno", name: "Elan & Elite Stairlifts" },
      { brand: "Harmar", name: "Pinnacle SL600 Stairlift" },
    ],
  },
  {
    slug: "medical-beds",
    title: "Medical Beds",
    icon: BedDouble,
    short: "Adjustable hospital and homecare beds delivered, assembled and serviced.",
    image: "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/b01dfd89ced0f8015f582ad1e2a74ff0017630b83dbe42f4c61428ce93caab1e.png",
    details: [
      "Semi-electric & full-electric homecare beds",
      "Rail, mattress & motor support",
      "Delivery, setup & relocation",
    ],
    products: [
      { brand: "Drive DeVilbiss", name: "Full- & Semi-Electric Homecare Beds" },
      { brand: "Medline", name: "Homecare & Bariatric Beds" },
      { brand: "Invacare", name: "Hospital & Low Beds" },
    ],
  },
  {
    slug: "scooters",
    gallery: [
      "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/4376d2bde7e17265e9410017a3c02d02e4fc80da89bfb02e964f676d8855a697.png",
      "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/981bf11b2e984b4f106b5ca85d25113547a62610e9973b07fee9f0d8b38e61ab.png",
      "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/732df16fd8c328d7793d53876c3d3f51dc5c28c3dbbdd5d9e7152e05d7a568df.png",
    ],
    title: "Scooters",
    icon: Bike,
    short: "Travel and full-size mobility scooters to keep you moving, indoors and out.",
    image: "https://images.pexels.com/photos/18681259/pexels-photo-18681259.jpeg?auto=compress&cs=tinysrgb&w=1000",
    details: [
      "3 & 4-wheel travel and heavy-duty models",
      "Battery, tire & controller repair",
      "Tune-ups and safety checks",
    ],
    products: [
      { brand: "Pride Mobility", name: "Go-Go\u00ae & Victory\u00ae Scooters" },
      { brand: "Golden Technologies", name: "Buzzaround\u00ae & Companion\u00ae Scooters" },
      { brand: "Drive DeVilbiss", name: "Scout & Phoenix Scooters" },
      { brand: "Merits Health", name: "Pioneer & Roadster Scooters" },
    ],
  },
  {
    slug: "powerchairs",
    title: "Powerchairs",
    icon: Joystick,
    short: "Power chairs set up, programmed and repaired for reliable daily use.",
    image: "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/ba7ab8ab831c60b0620e716fae4ee37be3c78ada0c488c341d2460e11acc2593.png",
    details: [
      "Joystick & controller programming",
      "Motor, brake & battery service",
      "Seating & positioning adjustments",
    ],
    products: [
      { brand: "Permobil", name: "F5 Corpus & M-Series Power Chairs" },
      { brand: "Pride Mobility", name: "Jazzy\u00ae & Quantum Power Chairs" },
      { brand: "Golden Technologies", name: "Compass\u00ae Power Chairs" },
      { brand: "Merits Health", name: "Vision & Regal Power Chairs" },
    ],
  },
  {
    slug: "motorized-wheelchairs",
    gallery: [
      "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/cddbecf88557c6ff444fd8bc9eaa2b114da4129240cf9f32d7f5c413a2781ea1.png",
      "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/513907e0e740ab00a1bd0037e5293b2c56dc538914bcb6e132303534b6b2a383.png",
      "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/9ca97439ea045ef65ccc82adc8d342fca938e643b09334c8f7d6100cc468b1b0.png",
    ],
    title: "Motorized Wheelchairs",
    icon: Accessibility,
    short: "Complex-rehab and everyday electric wheelchairs maintained and repaired.",
    image: "https://images.pexels.com/photos/20164641/pexels-photo-20164641.jpeg?auto=compress&cs=tinysrgb&w=1000",
    details: [
      "Diagnostics for all major brands",
      "Electronics & wiring repair",
      "Wheel, caster & tire replacement",
    ],
    products: [
      { brand: "Permobil", name: "F-Series & M-Series Wheelchairs" },
      { brand: "Quantum / Pride", name: "Edge & Q-Series Wheelchairs" },
      { brand: "Drive DeVilbiss", name: "Titan & Trident Wheelchairs" },
      { brand: "Merits Health", name: "Power Wheelchairs" },
    ],
  },
  {
    slug: "transport-lifts",
    gallery: [
      "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/02addd684cf530abee328d81e9df1fb6c290bcdd55f513ac5339f3e524ed0ac3.png",
      "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/d0c5ad69403847296ffbb11c27b5dba460c001f4eaacc8a1b20afbfc1aeb21d8.png",
      "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/632c8413005576977ad36f355deff78fb0598955688fd9e2923592d28cdf8b4c.png",
    ],
    title: "Transport Lifts",
    icon: MoveVertical,
    short: "Patient and vehicle transport lifts installed and kept running safely.",
    image: "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/6a8a6c58ee0108255ee862b8e97e540b4198a29875a97f3102b86943cf18997b.png",
    details: [
      "Patient (Hoyer-style) & vehicle lifts",
      "Hydraulic & electric service",
      "Sling & strap inspection",
    ],
    products: [
      { brand: "Bruno", name: "Out-Rider & Joey Vehicle Lifts" },
      { brand: "Harmar", name: "AL-Series Vehicle Lifts" },
      { brand: "Invacare / Medline", name: "Hoyer-style Patient Lifts" },
    ],
  },
  {
    slug: "electronic-repair",
    gallery: [
      "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/d9e614a05a0674b5fe45170d687219aae684bc2cce4fac3e697744cc40eadcd6.png",
      "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/7aa63f366fb9ee7a1293e8281657a27372b538384c0a523a034fed7f90ce0ee6.png",
      "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/fb2c979cba4ca272055362ce470b8ec4777a3977aa7ccdbc38cecb35f84eb019.png",
    ],
    title: "Electronic & Micro-Electronic Repair",
    icon: CircuitBoard,
    short: "Circuit boards, control modules and joystick electronics diagnosed and repaired down to the component level.",
    image: "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/6d9c2197e7be8f59fbb1116553da1b80237e471a78e6c60ec8f6c9e2e29adf65.png",
    details: [
      "Control module & joystick board repair",
      "Micro-soldering & component-level fixes",
      "Wiring, connector & charger-port repair",
    ],
    products: [
      { brand: "PG Drives / Curtiss-Wright", name: "Control Modules" },
      { brand: "Dynamic / Q-Logic", name: "Joystick Controllers" },
      { brand: "MK Battery", name: "Batteries & Chargers" },
      { brand: "All major brands", name: "Wiring Harnesses & Charger Ports" },
    ],
  },
  {
    slug: "ada-home-improvements",
    gallery: [
      "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/b7114651577740a3d738786ea6291a1a71efd0f19e23a3640ebe49e9ed92f9ff.png",
      "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/008703e9ac4ea3239fc41f1eae8fc7dd862551578ec0ba976275ba5cb44d551b.png",
      "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/648da07a37448bbf2f03fb7179b4d6fa1e2d84d70bed634c313d886130af6af7.png",
    ],
    title: "ADA Home Improvements",
    icon: Hammer,
    short: "ADA-compliant ramps, grab bars and accessibility upgrades for safer living.",
    image: "https://static.prod-images.emergentagent.com/jobs/46ab6ea2-f6e9-4f9d-ba33-b9f7b13ae7ed/images/69f9bd228de8475a063b2cfabb3de35f3eceb116497502928f8045fb7b484d1f.png",
    details: [
      "Wheelchair ramps & threshold ramps",
      "Grab bars & bathroom safety",
      "Widened doorways & accessible layouts",
    ],
    products: [
      { brand: "EZ-Access", name: "Wheelchair & Threshold Ramps" },
      { brand: "Drive / Medline", name: "Grab Bars & Bathroom Safety" },
      { brand: "Custom Build", name: "Widened Doorways & Accessible Layouts" },
    ],
  },
];

export const brands = [
  {
    slug: "pride-mobility",
    name: "Pride Mobility",
    tagline: "Power chairs, scooters & lift recliners",
    url: "https://www.pridemobility.com",
    blurb:
      "Industry-leading power chairs, travel scooters and Pride power lift recliners engineered for everyday independence.",
    categories: [
      "Jazzy\u00ae Power Chairs",
      "Go-Go\u00ae Travel Scooters",
      "Victory\u00ae Scooters",
      "Pride\u00ae Power Lift Recliners",
    ],
    resources: [
      { label: "Owner's Manuals & Support", url: "https://www.pridemobility.com/owners-manuals/" },
      { label: "Visit Pride Mobility", url: "https://www.pridemobility.com" },
    ],
  },
  {
    slug: "permobil",
    name: "Permobil",
    tagline: "Advanced power wheelchairs & seating",
    url: "https://www.permobil.com",
    blurb:
      "Premium power wheelchairs and advanced seating & positioning systems built for complex rehab and active lifestyles.",
    categories: [
      "F-Series & M-Series Power Chairs",
      "SmartDrive Power Assist",
      "Seating & Positioning",
      "Standing Power Chairs",
    ],
    resources: [
      { label: "Product Support", url: "https://www.permobil.com/en-us/support" },
      { label: "Visit Permobil", url: "https://www.permobil.com" },
    ],
  },
  {
    slug: "golden-technologies",
    name: "Golden Technologies",
    tagline: "Comfort & mobility, American made",
    url: "https://www.goldentech.com",
    blurb:
      "American-made lift chairs, scooters and power chairs known for exceptional comfort and long-lasting reliability.",
    categories: [
      "MaxiComfort\u00ae Lift Chairs",
      "Power Lift Recliners",
      "Buzzaround\u00ae Scooters",
      "Compass\u00ae Power Chairs",
    ],
    resources: [
      { label: "Manuals & Support", url: "https://www.goldentech.com" },
      { label: "Visit Golden Technologies", url: "https://www.goldentech.com" },
    ],
  },
  {
    slug: "mk-battery",
    name: "MK Battery",
    tagline: "Trusted power for mobility",
    url: "https://www.mkbattery.com",
    blurb:
      "Sealed AGM and gel batteries that keep powered mobility devices running reliably, mile after mile.",
    categories: [
      "AGM Sealed Batteries",
      "Gel Batteries",
      "U1 / Group 22NF Mobility Sizes",
      "Battery Chargers",
    ],
    resources: [
      { label: "Battery Specs & Selector", url: "https://www.mkbattery.com" },
      { label: "Visit MK Battery", url: "https://www.mkbattery.com" },
    ],
  },
  {
    slug: "drive-devilbiss",
    name: "Drive DeVilbiss",
    tagline: "Quality home medical equipment",
    url: "https://www.drivemedical.com",
    blurb:
      "A broad catalog of mobility and home medical equipment \u2014 wheelchairs, scooters, beds, rollators and more.",
    categories: [
      "Manual & Transport Wheelchairs",
      "Mobility Scooters",
      "Homecare Beds",
      "Rollators & Walkers",
    ],
    resources: [
      { label: "Product Resources", url: "https://www.drivemedical.com" },
      { label: "Visit Drive DeVilbiss", url: "https://www.drivemedical.com" },
    ],
  },
  {
    slug: "medline",
    name: "Medline",
    tagline: "Home care & medical supplies",
    url: "https://www.medline.com",
    blurb:
      "Home care essentials and durable medical equipment, from wheelchairs and walkers to everyday supplies.",
    categories: [
      "Wheelchairs & Transport Chairs",
      "Rollators & Walkers",
      "Patient Lifts",
      "Home Care Supplies",
    ],
    resources: [
      { label: "Product Catalog", url: "https://www.medline.com" },
      { label: "Visit Medline", url: "https://www.medline.com" },
    ],
  },
  {
    slug: "roho",
    name: "ROHO",
    tagline: "Air-cell skin protection",
    url: "https://www.permobil.com/en-us",
    blurb:
      "Pioneering air-cell cushions and seating that protect skin and help prevent pressure injuries for wheelchair users.",
    categories: [
      "ROHO\u00ae Air Cushions",
      "Skin Protection Seating",
      "Back Support Systems",
      "Mattress Overlays",
    ],
    resources: [
      { label: "Product Support", url: "https://www.permobil.com/en-us" },
      { label: "Visit ROHO (Permobil)", url: "https://www.permobil.com/en-us" },
    ],
  },
  {
    slug: "comfort-company",
    name: "The Comfort Company",
    tagline: "Comfort, positioning & protection",
    url: "https://www.comfortcompany.com",
    blurb:
      "Durable wheelchair cushions and backs engineered for comfort, positioning and long-term skin protection.",
    categories: [
      "Wheelchair Cushions",
      "Back Supports",
      "Positioning Components",
      "Bariatric Seating",
    ],
    resources: [
      { label: "Product Catalog", url: "https://www.comfortcompany.com" },
      { label: "Visit The Comfort Company", url: "https://www.comfortcompany.com" },
    ],
  },
  {
    slug: "stealth-products",
    name: "Stealth Products",
    tagline: "Advanced positioning",
    url: "https://www.stealthproducts.com",
    blurb:
      "Headrests, positioning hardware and seating components that deliver precise, custom support for every rider.",
    categories: [
      "Headrests",
      "Positioning Hardware",
      "Seating Components",
      "Drive Controls",
    ],
    resources: [
      { label: "Support & Resources", url: "https://www.stealthproducts.com" },
      { label: "Visit Stealth Products", url: "https://www.stealthproducts.com" },
    ],
  },
  {
    slug: "e-wheelz",
    name: "e-wheelz",
    tagline: "Powered freedom",
    url: "https://www.ewheelsdealers.com",
    blurb:
      "Electric mobility solutions and powered drives built to extend your range and keep you independent on the go.",
    categories: [
      "Electric Mobility",
      "Power-Assist Drives",
      "Batteries & Chargers",
      "Accessories",
    ],
    resources: [
      { label: "Explore models", url: "https://www.ewheelsdealers.com" },
      { label: "Visit e-wheelz", url: "https://www.ewheelsdealers.com" },
    ],
  },
  {
    slug: "acorn",
    name: "Acorn Stairlifts",
    tagline: "Straight, curved & outdoor stairlifts",
    url: "https://www.acornstairlifts.com",
    blurb:
      "The world's leading stairlift specialist \u2014 straight, curved and outdoor stairlifts that keep every floor of your home within reach.",
    categories: [
      "Straight Stairlifts",
      "Curved Stairlifts",
      "Outdoor Stairlifts",
      "Reconditioned Stairlifts",
    ],
    resources: [
      { label: "Product Support", url: "https://www.acornstairlifts.com" },
      { label: "Visit Acorn Stairlifts", url: "https://www.acornstairlifts.com" },
    ],
  },
  {
    slug: "merits",
    name: "Merits Health",
    tagline: "Quality mobility for life",
    url: "https://www.meritshealth.com",
    blurb:
      "Dependable power wheelchairs, scooters and lift chairs designed for comfort, durability and everyday independence.",
    categories: [
      "Power Wheelchairs",
      "Mobility Scooters",
      "Power Lift Chairs",
      "Rollators & Walkers",
    ],
    resources: [
      { label: "Power Wheelchairs", url: "https://www.meritshealth.com/power-wheelchairs" },
      { label: "Visit Merits Health", url: "https://www.meritshealth.com" },
    ],
  },
];

export const serviceRegions = [
  {
    name: "Central Pennsylvania",
    note: "Our home base \u2014 fast local service",
    areas: [
      "Cambria County, PA",
      "Blair County, PA",
      "Bedford County, PA",
      "Somerset County, PA",
      "Martinsburg, PA",
    ],
  },
  {
    name: "Tri-State Region",
    note: "Including area VA Medical Centers",
    areas: [
      "Martinsburg VA Medical Center",
      "Martinsburg, WV",
      "Hagerstown, MD",
    ],
  },
];

// Serviced PA counties (label + approx [lng, lat] centroid for the map)
export const servicedCounties = [
  { name: "Cambria", coords: [-78.70, 40.50] },
  { name: "Blair", coords: [-78.35, 40.48] },
  { name: "Bedford", coords: [-78.49, 40.01] },
  { name: "Somerset", coords: [-79.05, 40.02] },
];

// Home base for the service-radius map
export const homeBase = { name: "Johnstown, PA", coords: [-78.922, 40.327] };

// Local VA Medical Centers across the region [lng, lat].
// inRadius = within ~2.5 hours' drive of Johnstown, PA.
export const vaMedicalCenters = [
  // Pennsylvania
  { name: "James E. Van Zandt VAMC (Altoona)", state: "PA", coords: [-78.394, 40.499], inRadius: true },
  { name: "Pittsburgh VAMC (University Dr)", state: "PA", coords: [-79.959, 40.438], inRadius: true },
  { name: "H. John Heinz III VAMC (Pittsburgh)", state: "PA", coords: [-79.903, 40.494], inRadius: true },
  { name: "Butler VAMC", state: "PA", coords: [-79.913, 40.872], inRadius: true },
  { name: "Erie VAMC", state: "PA", coords: [-80.073, 42.103] },
  { name: "Lebanon VAMC", state: "PA", coords: [-76.424, 40.350] },
  { name: "Coatesville VAMC", state: "PA", coords: [-75.803, 39.991] },
  { name: "Wilkes-Barre VAMC", state: "PA", coords: [-75.861, 41.265] },
  { name: "Crescenz VAMC (Philadelphia)", state: "PA", coords: [-75.207, 39.950] },
  // West Virginia
  { name: "Martinsburg VAMC", state: "WV", coords: [-77.964, 39.455], inRadius: true },
  { name: "Louis A. Johnson VAMC (Clarksburg)", state: "WV", coords: [-80.342, 39.277], inRadius: true },
  { name: "Beckley VAMC", state: "WV", coords: [-81.205, 37.793] },
  { name: "Hershel Woody Williams VAMC (Huntington)", state: "WV", coords: [-82.425, 38.416] },
  // Maryland
  { name: "Baltimore VAMC", state: "MD", coords: [-76.622, 39.288] },
  { name: "Perry Point VAMC", state: "MD", coords: [-76.073, 39.550] },
  // Virginia
  { name: "McGuire VAMC (Richmond)", state: "VA", coords: [-77.453, 37.502] },
  { name: "Hampton VAMC", state: "VA", coords: [-76.360, 37.021] },
  { name: "Salem VAMC", state: "VA", coords: [-80.073, 37.290] },
];

export const faqs = [
  {
    q: "Do you work on both powered and non-powered mobility devices?",
    a: "Yes. From manual wheelchairs and rollators to power chairs, scooters, lift chairs and stair lifts \u2014 if it helps you move, we can help you with it. Call or text with any issue or concern.",
  },
  {
    q: "Do you work with the VA and serve Veterans?",
    a: "Absolutely. JRs Chair Repair is a Veteran-owned business and we proudly serve fellow Veterans, including work in and around area VA Medical Centers. Reach out and we'll walk you through your options.",
  },
  {
    q: "What areas do you serve?",
    a: "We cover Cambria, Blair, Bedford and Somerset counties in Pennsylvania, plus Martinsburg, WV (and the VA Medical Center) and Hagerstown, MD. Not sure if you're in range? Just call.",
  },
  {
    q: "Do you deliver and set up equipment, or only repair it?",
    a: "Both. We deliver, assemble and set up new equipment in your home, and we repair and maintain devices you already own.",
  },
  {
    q: "How do I get started?",
    a: "Call or text John at 814-410-5822, or send a request through the contact form. Tell us what's going on and we'll take it from there.",
  },
];

export const testimonials = [
  {
    quote:
      "John came out fast and got my mother's lift chair working again the same day. Honest, respectful and clearly knows what he's doing.",
    name: "Sharon M.",
    location: "Blair County, PA",
  },
  {
    quote:
      "Being a Veteran myself, it meant a lot to work with another Veteran. He set up my power chair and explained everything in plain English.",
    name: "Robert T.",
    location: "Martinsburg, WV",
  },
  {
    quote:
      "Installed a ramp and grab bars so I could get my husband in and out safely. Fair price and great work \u2014 highly recommend.",
    name: "Donna K.",
    location: "Somerset County, PA",
  },
];

export const trustPoints = [
  { label: "Veteran Owned", sub: "Built on service & integrity" },
  { label: "Powered & Non-Powered", sub: "Any mobility device" },
  { label: "Delivery & Repair", sub: "In-home service" },
  { label: "Call or Text", sub: "814-410-5822" },
];
